
namespace PaperTrail.NewsletterControl {

    @Serenity.Decorators.registerClass()
    export class NewsletterContributorGrid extends Serenity.EntityGrid<NewsletterRow, any> {
        protected getColumnsKey() {
            if (Q.Authorization.hasPermission(PermissionKeys.Organizer)) {
                return NewsletterContributorColumns.columnsKey;
            }
            else {
                return NewsletterContributorColumns.columnsKey;
            }
        }
        protected getDialogType() { return NewsletterDialog; }
        protected getIdProperty() { return NewsletterRow.idProperty; }
        protected getInsertPermission() { return NewsletterRow.insertPermission; }
        protected getLocalTextPrefix() { return NewsletterRow.localTextPrefix; }
        protected getService() { return NewsletterService.baseUrl; }


        //protected rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.enableCellNavigation = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());

            // *** Enable Full size grid resize ***
            Common.GridHelper.EnableFullSizeGrid();

            var test = new Serenity.AutoColumnWidthMixin({
                grid: this
            });
            return grid;
        }

        private autoSize;
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();

            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();

            columns.forEach(col => col.cssClass += " col-allowBackground");  
            columns.unshift({
                field: 'Write Story',
                name: 'WriteStory',
                
                format: ctx => '<a class="inline-action write-story" title="write a story">' +
                    '<i class="fa fa-pen-fancy">Write a Story!</i></a>',
                width: 130,
                minWidth: 130,
                maxWidth: 160,
                sortable: false,
                resizable: false
            });
            columns.unshift({
                field: 'View Stories',
                name: 'View Stories',

                format: ctx => '<a class="inline-action view-stories" title="View your stories">' +
                    '<i class="fa fa-book"></i>View your stories!</a>',
                width: 130,
                minWidth: 130,
                maxWidth: 160,
                sortable: false,
                resizable: false
            });
              
            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            let self = this;

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row) as NewsletterRow;

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();
                if (target.hasClass('write-story')) {

                    var sdlg = new NewsletterControl.StoryContributorDialog();
                    this.initDialog(sdlg);
                    sdlg.loadEntityAndOpenDialog(<NewsletterControl.StoryRow>{
                        NewslettersList: [item.NewsletterId]
                    });
                }
                if (target.hasClass('view-stories')) {
                    this.slickGrid.setSelectedRows(row);
                }
            }
        }
    }
}